module.exports = __webpack_public_path__ + "static/media/CroppedProfileImage.37110a13.jpg";